import { Injectable } from '@angular/core';
import { DynamicExternalLink } from '@navigation';
import { Config } from '@config';
import { PlantService } from '@plants';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { RoutingInfoService } from '@routing';

@Injectable()
export class WebAccessDynamicExternalLink implements DynamicExternalLink {
    constructor(
        private config: Config,
        private plantService: PlantService,
        private sanitizer : DomSanitizer,
        private routingInfoService: RoutingInfoService,
    ){}

    public async getLink() : Promise<SafeUrl>{
        await this.routingInfoService.waitForParam('plantid');
        const plant = await this.plantService.getCurrentPlant();
        if(
            plant.isMeteringDevice
            && plant.serialNumber.startsWith('EV')
            && this.config.meteringAccessWebUrl
        ){
            return this.config.meteringAccessWebUrl + '' + plant.serialNumber;
        }
    }
}